module.exports = __webpack_public_path__ + "static/media/tablets3.d5fd44da.png";